<script>
  import options from './PostComment.options'
  export default options
</script>

<template>
  <article class="kb-post-comment" :id="comment.id">   

    <button class="kb-post-comment__top"  
          v-on:click="(e) => startUserInfoOverlay(e)"
          aria-haspopup="true"
          v-bind:aria-expanded="userInfoExpanded">
      <figure 
        class="kb-image-module kb-image-module--1-1 kb-post-comment__top-profile-img"
          :class="{ 'kb-post-comment__top-profile-img--disabled-click' : comment.authorId == undefined }">
          <div class="kb-image-module__image-container">
              <picture class="kb-image-module__image">
                  <img :src="comment.profileImage" alt="Profile image" />
              </picture>
          </div>
      </figure>
      <div class="kb-post-comment__top-texts">
        <div
          class="kb-post-comment__top-post-author-data"
          :class="{ 'kb-post-comment__top-post-author-data--disabled-click' : comment.authorId == undefined }"
           >
          <p class="kb-post-comment__top-post-author-data-name">
              {{ comment.author }}
          </p>
          <div class="kb-post-comment__top-post-author-data-date-wrapper">
            <p class="kb-post-comment__top-post-author-data-date">{{ comment.timestamp }}</p>
            <p  v-if="comment.edited" class="kb-post-comment__top-post-author-data-date kb-post-comment__top-post-author-data-date--edited">
                {{ getLabel('edited') }}: {{ comment.edited.timestamp }}
                <span>{{ comment.edited.author }}</span>
            </p>
          </div>
        </div>
      </div>
    </button>

    <div class="kb-post-comment__post">

      <template v-if="!isEditingComment">
        <div class="kb-post-comment__post-edit" v-if="comment.canEdit">
          <button class="kb-link" v-on:click="handleDeleteComment">{{ getLabel('deleteComment') }}</button>
          <button class="kb-link" v-on:click="handleEditComment">{{ getLabel('editComment') }}</button>
        </div>
        <div class="kb-post-comment__post-text" v-html="comment.content"></div>

        <AttachmentsViewer :files="comment.files"/>

        <div class="kb-post-comment__post-bottom">
          <button v-if="canReply" v-on:click="scrollToAddSubComment" class="kb-button kb-button--full-color-spot">{{ getLabel('commentAnswerButton') }}</button>
        </div>
      </template>

      <div class="kb-post-comment__post-editor" v-else>
          <editor api-key="no-api-key" :init='{
              plugins: "emoticons autoresize lists autolink",
              toolbar: "emoticons bold italic underline bullist numlist",
              toolbar_location: "bottom",
              menubar: false,
              statusbar: false,
              license_key: "gpl"
            }'
            v-model="editCommentContent"
          ></editor>
          <div class="kb-post-comment__post-bottom">
            <button class="kb-button kb-button--full-color-spot" v-on:click="handleSaveEditedComment" :disabled="isSubmitting">{{ getLabel('saveEditComment') }}</button>
            <button class="kb-button kb-button--spot-border-color" v-on:click="handleCancelEditedComment" :disabled="isSubmitting">{{ getLabel('cancelEditComment') }}</button>
          </div>

          <AttachmentsEditor
            :files="comment.files"
            @update:filesToAdd="$event => editCommentFilesToAdd = $event"
            @update:filesToRemove="$event => editCommentFilesToRemove = $event"
          />

      </div>

    </div>  

    <div class="kb-post-comments__comment__sub-comments">
      <template v-for="subComment, indexSub in subComments" :key="indexSub"> 
        <div class="kb-post-comments__comment__sub-comments-comment">
          <PostComment
          :comment="subComment"
          :groupId="groupId"
          :canLike="canLike"
          :isFrivilligContext="isFrivilligContext"
          />
        </div>
      </template>

      <div v-if="isAddingSubcomment" class="kb-post-comments__comment__sub-comments-comment">
          <div class="kb-post-comment__new-comment kb-stafet-step" ref="addSubCommentRef">
            <div class="kb-post-comment__new-comment-editor">
              <editor api-key="no-api-key" :init='{
                  plugins: "emoticons autoresize lists autolink",
                  toolbar: "emoticons bold italic underline bullist numlist",
                  toolbar_location: "bottom",
                  menubar: false,
                  statusbar: false,
                  license_key: "gpl"
                }'
                v-model="subCommentContent"
              ></editor>

              <AttachmentsEditor
                :files="[]"
                @update:filesToAdd="subCommentFilesToAdd = $event"
                ref="subCommentAttachments"
              />

            </div>
            <button 
              :aria-label="getLabel('newCommentAriaLabel')"
              class="kb-post-comment__new-comment-button" 
              :class="{
                'kb-post-comment__new-comment-button--disabled': subCommentSubmitButtonDisabled,
                'kb-post-comment__new-comment-button--submitting': isSubmitting,
              }"
              v-on:click="submitNewSubComment">
              <svg viewBox="0 0 25 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m18.251 1 5.434 6-5.434 6" stroke="#fff" stroke-linejoin="round"/><path d="M17.62 7H0" stroke="#fff"/></svg> 
            </button>
          </div>
        </div>
    </div>

  </article>
</template>
